import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject, Inject } from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import { TranslatePipe } from 'src/app/shared/pipes/translate/translate.pipe';
import { DocumentTreeApiService } from 'src/app/api/bizzmine/document-tree/document-tree-api.service';
import { take } from 'rxjs';
import { UnlinkFromFolderParams } from './interfaces/unlink-from-folder-params';
import { InheritType } from 'src/models/ts/inherit-type.model';
import { FolderInstanceTargetType } from 'src/models/ts/folder-instance-target-type.model';
import { IconComponent } from '../../ui/icon/icon.component';
import { refreshActions } from 'src/app/store/features/refresh/refresh-actions';
import { Store } from '@ngrx/store';
import { PwaService } from 'src/app/core/services/pwa/pwa.service';
import { KeepOfflineService } from 'src/app/core/services/keep-offline/keep-offline.service';
import { SyncService } from 'src/app/core/services/sync/sync.service';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { AlertService } from 'src/app/features/bizzmine/alerts/alert.service';

@Component({
  selector: 'bizz-unlink-from-folder-modal',
  standalone: true,
  imports: [TranslatePipe, ModalComponent, IconComponent],
  templateUrl: './unlink-from-folder-modal.component.html',
  styleUrl: './unlink-from-folder-modal.component.scss'
})
export class UnlinkFromFolderModalComponent {

  protected readonly InheritType = InheritType;
  protected readonly FolderInstanceTargetType = FolderInstanceTargetType;
  private pwaService = inject(PwaService);
  private keepOfflineService = inject(KeepOfflineService);
  private syncService = inject(SyncService);
  private alertService = inject(AlertService);
  private translationService = inject(TranslationService);

  public constructor(
    public dialogRef: DialogRef,
    @Inject(DIALOG_DATA) public modalData: UnlinkFromFolderParams,
    private documentTreeApiService: DocumentTreeApiService,
    private store$: Store
  ) {
    this.dialogRef.disableClose = true;
  }

 

  public unlink(): void {
    if (this.modalData.widgetId)
      this.documentTreeApiService.unlinkFromFolder(this.modalData.widgetId, this.modalData.folderId, this.modalData.collectionId, this.modalData.instanceId)
        .pipe(take(1))
        .subscribe({
          next: () => {
            this.store$.dispatch(refreshActions.refreshData({collectionId: this.modalData.collectionId}));
            this.dialogRef.close();
            if(this.pwaService.isPwa() && this.keepOfflineService.offlineInstanceCached(this.modalData.collectionId, this.modalData.instanceId, this.modalData.versionId, !!this.modalData.folderId)){
              this.syncService.unlinkInstance(this.modalData.collectionId, this.modalData.instanceId, this.modalData.versionId, this.modalData.folderId);
            }
          },
          error: () => {
            //TODO: handle error
          },
        });
  }

}
